import { createSlice } from '@reduxjs/toolkit';

const features = createSlice({
  name: 'FEATURES',
  initialState: {},

  reducers: {
    setIsBounceNavigationAnimationEnabled: (state, action) => {
      state.isBounceNavigationAnimationEnabled =
        action.payload.isBounceNavigationAnimationEnabled;
    },
    setShowSmartMatchMeter: (state, action) => {
      state.showSmartMatchMeter = action.payload.showSmartMatchMeter;
    },
    setShowSmartMatchMeterV2: (state, action) => {
      state.showSmartMatchMeterV2 = action.payload.showSmartMatchMeterV2;
    },
    setEnableResultsPage: (state, action) => {
      state.enableResultsPage = action.payload.enableResultsPage;
    },
    setSupplierMatchCountUp: (state, action) => {
      state.supplierMatchCountUp = action.payload.supplierMatchCountUp;
    },
    setCaptureBsaLeadsOnAbandonedFlows: (state, action) => {
      state.captureBsaLeadsOnAbandonedFlows =
        action.payload.captureBsaLeadsOnAbandonedFlows;
    },
    setDynamicSelectAndConnect: (state, action) => {
      const { maxBrands, enableDynamicSelectAndConnect } = action.payload;
      // The component's own dynamic toggle may already have turned the
      // feature on at store build time, so the loader flag can only add to it.
      const current = state.dynamicSelectAndConnect || {};

      state.dynamicSelectAndConnect = {
        maxBrands: maxBrands ?? current.maxBrands,
        enableDynamicSelectAndConnect:
          Boolean(current.enableDynamicSelectAndConnect) ||
          Boolean(enableDynamicSelectAndConnect),
      };
    },
    setOneToOneSupplierConsent: (state, action) => {
      state.oneToOneSupplierConsent = action.payload.oneToOneSupplierConsent;
    },
  },
});

const { actions } = features;

export const {
  setIsBounceNavigationAnimationEnabled,
  setShowSmartMatchMeter,
  setShowSmartMatchMeterV2,
  setEnableResultsPage,
  setSupplierMatchCountUp,
  setCaptureBsaLeadsOnAbandonedFlows,
  setDynamicSelectAndConnect,
  setOneToOneSupplierConsent,
} = actions;

export default features.reducer;
